import { getAssetExportQuery, getDownloadContent } from 'services'
import useDownloads from './useDownload'
import { DOWNLOAD_OPTIONS } from '../components/DownloadBlock'
import { useDispatch } from 'react-redux'
import {
  DownloadStatus,
  addItemToDownloadState,
  setDownloadStatus,
} from 'redux/reducers/downloadReducer'
import { common } from 'database/db'

const useOfflineDownloadManager = () => {
  const { startDownloads } = useDownloads()
  const dispatch = useDispatch()

  const startDownloadContent = async (downloadOptions: string[]) => {
    let dataDownloadURLs
    if (downloadOptions.includes(DOWNLOAD_OPTIONS.ALL)) {
      dataDownloadURLs = await getDownloadContent({
        homeAndGarden: true,
        professional: true,
      })
    } else if (downloadOptions.includes(DOWNLOAD_OPTIONS.HOME_AND_GARDEN)) {
      dataDownloadURLs = await getDownloadContent({
        homeAndGarden: true,
      })
    } else if (downloadOptions.includes(DOWNLOAD_OPTIONS.PROFESSIONAL)) {
      dataDownloadURLs = await getDownloadContent({
        professional: true,
      })
    }
    if (!dataDownloadURLs) return

    await startDownloads(dataDownloadURLs)
  }

  const startDownloadImages = async (downloadOptions: string[]) => {
    let downloadType: 'all' | 'hg' | 'pro' | undefined
    if (downloadOptions.includes(DOWNLOAD_OPTIONS.ALL)) {
      downloadType = 'all'
    } else if (downloadOptions.includes(DOWNLOAD_OPTIONS.HOME_AND_GARDEN)) {
      downloadType = 'hg'
    } else if (downloadOptions.includes(DOWNLOAD_OPTIONS.PROFESSIONAL)) {
      downloadType = 'pro'
    }

    if (!downloadType) return
    const assetExport = await getAssetExportQuery(downloadType)

    if (!assetExport || !assetExport.URL) return

    const imageDownloadURLs = {} as { [key: string]: string }
    assetExport.URL.forEach((assetExport, index) => {
      dispatch(addItemToDownloadState(`${downloadType?.toUpperCase()}_${index + 1}`))
      imageDownloadURLs[`${downloadType?.toUpperCase()}_${index + 1}`] = assetExport
    })
    await startDownloads(imageDownloadURLs)
  }

  const startOfflineDownload = async (downloadOptions: string[]) => {
    if (downloadOptions.length === 0) return
    dispatch(setDownloadStatus(DownloadStatus.Downloading))

    await common.delete()

    await startDownloadContent(downloadOptions)

    await startDownloadImages(downloadOptions)

    dispatch(setDownloadStatus(DownloadStatus.Finished))
  }

  return { startOfflineDownload }
}

export default useOfflineDownloadManager
